@if (loading) {
  <div class="loader-container" style="background-color:white">
    <div class="loader">
      <div class="logo-anim-wrapper" style="width:15vw;">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.98 58.98" class="leanbyte-logo-animated" style="width:100%;height:auto;">
          <path class="logo-part logo-border" fill="#0f5ef8" d="M55.71,21.58l-9.16-9.16-4.39,4.39L51.32,26a5,5,0,0,1,0,7.06L33,51.32a5,5,0,0,1-7,0L7.66,33a5,5,0,0,1,0-7.06L26,7.66a5,5,0,0,1,7.05,0l4.75,4.76L42.16,8,37.4,3.28a11.19,11.19,0,0,0-15.83,0L3.27,21.58a11.2,11.2,0,0,0,0,15.82l18.3,18.31a11.21,11.21,0,0,0,15.83,0l18.31-18.3A11.21,11.21,0,0,0,55.71,21.58Z"/>
          <path class="logo-part logo-checkmark" fill="#00bc8b" d="M53.14,10.23a3.1,3.1,0,0,0-4.39,0L29.49,29.49,22.9,22.9a3.1,3.1,0,1,0-4.39,4.39l8.79,8.79a3.11,3.11,0,0,0,4.39,0s0,0,0,0L53.14,14.62A3.11,3.11,0,0,0,53.14,10.23Z"/>
        </svg>
      </div>
    </div>
  </div>
}
@if (!loading) {
  <router-outlet />
}
